import {
  Component,
  Vue,
} from 'vue-property-decorator';
import { GridItemNormalizer } from '@/classes/normalizers/types';
import {
  ObjectGridItemNormalizer,
  ClientObjectNormalizer,
  UserObjectNormalizer,
  CostObjectNormalizer,
  StatusApplicationObjectNormalizer,
  SupplierObjectNormalizer,
  PlantsHRObjectNormalizer,
  UnitsObjectNormalizer,
  WorkTypeObjectNormalizer,
  BooleanNormalizer,
  CostAccountObjectNormalizer,
} from '@/classes/normalizers/grid-item-normalizers';

@Component
export default class NormalizerMixin extends Vue {
  normalizers: Array<any> = [];

  beforeMount() {
    this.normalizers = [
      new ObjectGridItemNormalizer(),
      new ClientObjectNormalizer(),
      new UserObjectNormalizer(),
      new CostObjectNormalizer(),
      new StatusApplicationObjectNormalizer(),
      new SupplierObjectNormalizer(),
      new PlantsHRObjectNormalizer(),
      new UnitsObjectNormalizer(),
      new WorkTypeObjectNormalizer(),
      new BooleanNormalizer(),
      new CostAccountObjectNormalizer(),
    ];
  }

  getNormalizerRequiredFields(entity: string) {
    const normalizer = this.normalizers.find((n) => n.support({
      __typename: `object_${entity}`,
    }));
    return normalizer?.getRequiredFields();
  }

  normalizeValue(value: any) {
    const normalizer = this.normalizers.find((n) => n.support(value));
    let normalizedValue = value;
    if (normalizer) {
      normalizedValue = normalizer.normalize(value);
    }
    return normalizedValue;
  }

  normalizeValueAsSelectValue(value: any) {
    const normalizer = this.normalizers.find((n) => n.support(value));
    let normalizedValue = value;
    if (normalizer) {
      normalizedValue = normalizer.normalizeAsSelectValue(value);
    }
    if (value.showing_name !== undefined) {
      return value.showing_name;
    }
    return normalizedValue;
  }
}
